export default {
  formId: 'userForm',
  formField: {
    fullName: {
      name: 'fullName',
      label: 'Nome Completo*',
      requiredErrorMsg: 'Digite um nome completo.',
      invalidErrorMsg: 'Nome e sobrenome obrigatório',
    },
    email: {
      name: 'email',
      label: 'E-mail*',
      requiredErrorMsg: 'Insira um e-mail',
      invalidErrorMsg: 'Digite um email válido',
    },
    emailContact: {
      name: 'emailContact',
      label: 'E-mail de Contato*',
      requiredErrorMsg: 'Insira um e-mail de contato',
      invalidErrorMsg: 'Digite um email de contato válido',
    },
    registration: {
      name: 'registration',
      label: 'Matricula (opcional)',
    },
    cpf: {
      name: 'cpf',
      label: 'CPF',
      invalidErrorMsg: 'Digite um número de CPF válido',
    },
    phone1: {
      name: 'phone1',
      label: 'Telefone 1',
      requiredErrorMsg: 'Insira um número de telefone ',
    },
    phone2: {
      name: 'phone2',
      label: 'Telefone 2',
    },
    area: {
      name: 'area',
      label: 'Área*',
      requiredErrorMsg: 'Escolha uma área.',
    },
    subArea: {
      name: 'subArea',
      label: 'Sub área(opcional)',
    },
    office: {
      name: 'office',
      label: 'Cargo*',
      requiredErrorMsg: 'Escolha um cargo.',
    },
    manager: {
      name: 'manager',
      label: 'Gestor(opcional)',
    },
    specialNeed: {
      name: 'specialNeed',
      label: 'Possui Necessidades especiais',
    },
    zipCode: {
      name: 'zipCode',
      label: 'CEP',
      requiredErrorMsg: 'Insira seu cep.',
    },
    street: {
      name: 'street',
      label: 'Logradouro',
      requiredErrorMsg: 'Insira o nome do logradouro.',
    },
    number: {
      name: 'number',
      label: 'Número',
      requiredErrorMsg: 'Insira o número do seu endereço.',
    },
    complement: {
      name: 'complement',
      label: 'Complemento(opcional)',
    },
    district: {
      name: 'district',
      label: 'Bairro',
      requiredErrorMsg: 'Insira o nome do seu bairro.',
    },
    city: {
      name: 'city',
      label: 'Cidade',
      requiredErrorMsg: 'Insira o nome da sua cidade.',
    },
    state: {
      name: 'state',
      label: 'UF',
      requiredErrorMsg: 'Insira o UF.',
    },
    profiles: {
      name: 'profiles',
      label: 'Perfil*',
      requiredErrorMsg: 'Selecione um perfil',
    },
    groups: {
      name: 'groups',
      label: 'Função*',
      requiredErrorMsg: 'Selecione uma função',
    },
  },
};
